import React, { useState } from 'react';

import HelpVideoModal from 'components/molecules/help_video_modal';
import { CapagTypes } from 'store/modules/bidding_store/types';
import { CapagBadge, CapagIndicatorValue, Container } from './styles';

interface BiddingSummaryCapagProps {
  capag: CapagTypes;
}

const CAPAG_VIDEO_URL = 'https://player.vimeo.com/video/1166650077';

const formatRatio = (ratio: string) => {
  if (ratio === '-') return '0';
  const normalizedRatio = ratio.startsWith('-.') ? ratio.replace('-.', '-0.') : ratio;
  return normalizedRatio.replace('.', ',');
};

const BiddingSummaryCapag: React.FC<BiddingSummaryCapagProps> = ({ capag }) => {
  const [showVideo, setShowVideo] = useState(false);
  const indicators = [
    {
      label: 'Endividamento',
      rating: capag.debt_rating,
      ratio: capag.debt_ratio,
    },
    {
      label: 'Poupança corrente',
      rating: capag.current_savings_rating,
      ratio: capag.current_savings_ratio,
    },
    {
      label: 'Liquidez Relativa',
      rating: capag.relative_liquidity_rating,
      ratio: capag.relative_liquidity_ratio,
    },
  ];

  return (
    <Container className="mt-3">
      <div className="d-flex summary-capag-content">
        <CapagBadge
          variant={capag.capag}
          className="summary-capag-badge d-flex flex-column justify-content-around mr-md-2 mb-2 mb-md-0"
        >
          <span className="summary-capag-badge-title">Nota CAPAG</span>
          <span className="summary-capag-badge-value">{capag.capag}</span>
        </CapagBadge>

        <div className="summary-capag-indicators flex-grow-1">
          {indicators.map(({ label, rating, ratio }, index) => (
            <React.Fragment key={label}>
              <div className="summary-capag-indicator-row d-flex justify-content-between align-items-center">
                <strong className="summary-capag-indicator-label">{label}</strong>
                <CapagIndicatorValue variant={rating} className="rounded">
                  {rating}
                  <span className="mx-1">|</span>
                  {`${formatRatio(ratio)}%`}
                </CapagIndicatorValue>
              </div>
              {index < indicators.length - 1 && <hr className="m-0" />}
            </React.Fragment>
          ))}
        </div>
      </div>

      <p className="summary-capag-text mt-3 mb-2">
        Capacidade de Pagamento (Capag) sinaliza a saúde fiscal de Estados e Municípios para
        auxiliar licitantes na análise de risco orçamentário, sem avaliar, entretanto, o cumprimento
        histórico de pagamentos ou a pontualidade junto aos fornecedores.
      </p>

      <button
        type="button"
        className="btn btn-link p-0"
        onClick={() => setShowVideo(true)}
      >
        Saiba mais
      </button>

      <HelpVideoModal
        modalVideoOpened={showVideo}
        setModalVideoOpened={setShowVideo}
        urlVideo={CAPAG_VIDEO_URL}
        modalTitle="Vídeo explicativo CAPAG"
      />
    </Container>
  );
};

export default BiddingSummaryCapag;
